import { Id } from "PFTypes";

// sorting ids is required to properly use cache with optimistic update on options selection
const sortIds = (ids: Id[]): Id[] => [...ids].sort((idA, idB) => String(idA).localeCompare(String(idB)));

export const optionsKeys = {
  all: ["selectOptions"],
  dropdown: (dropdownId) => [...optionsKeys.all, dropdownId],
  dropdownWithParams: (dropdownId, searchId: Id = "", ids: Id[] = [], searchTerm = "") => [
    ...optionsKeys.all,
    dropdownId,
    searchId,
    sortIds(ids),
    searchTerm
  ]
};
